import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomInput from "../components/CustomInput";
import { base_url } from "../../utils/baseUrl";

const Appointment = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const getNewsId = location.pathname.split("/")[3]; // Get the ID from route params
    const token = useSelector((state) => state.autht.token);

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [date, setDate] = useState('');
    const [timeSlotID, setTimeSlotID] = useState('');

    const [availableSlots, setAvailableSlots] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Fetch initial data if editing an existing appointment
        if (getNewsId) {
            fetchAppointmentData(getNewsId);
        }
    }, [getNewsId]);

    useEffect(() => {

        if (date) {
            fetchAvailableSlots(date);
        }
    }, [date]);

    const fetchAppointmentData = async (id) => {
        try {
            setLoading(true);
            const response = await axios.get(`${base_url}appointments/${id}`);
            if (response.status === 200) {
                const { name, email, phone, date, timeSlotID } = response.data;
                setName(name);
                setEmail(email);
                setPhone(phone);
                setDate(date);
                setTimeSlotID(timeSlotID);
                // Fetch available slots for the selected date
                fetchAvailableSlots(date);
            } else {
                console.error('Error fetching appointment data: Unexpected status code', response.status);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching appointment data:', error);
            setLoading(false);
        }
    };

    const fetchAvailableSlots = async (date) => {
        try {
            setLoading(true);
            const response = await axios.get(`${base_url}bookings/available-slots/${date}`);

            if (response.status === 200) {
                if (response.data.availableSlots && response.data.availableSlots.length > 0) {
                    setAvailableSlots(response.data.availableSlots);
                    console.log("Available slots:", response.data.availableSlots);
                } else {
                    setAvailableSlots([]);
                }
            } else {
                console.error('Error fetching available slots: Unexpected status code', response.status);
                setAvailableSlots([]);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching available slots:', error);
            setAvailableSlots([]);
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = { name, email, phone, date, timeSlotID };

        try {
            if (getNewsId) {
                // Update existing appointment
                await axios.put(`${base_url}appointments/${getNewsId}`, formData);
                console.log('Appointment updated successfully');
            } else {
                // Create new appointment
                await axios.post(`${base_url}appointments`, formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                console.log('Appointment created successfully');
            }
            // Optionally handle success message or redirect to confirmation page
            navigate('/association/Appointment-List'); // Redirect to appointments page after submit
        } catch (error) {
            console.error('Error saving appointment:', error);
            // Handle error response from appointment API
        }
        setLoading(false);
    };
    if (loading) {
        return <div>Loading...</div>;
    }
    return (
        <div>
            <h3 className="mb-4 title">{getNewsId ? "Edit" : "Book"} Appointment</h3>

            <div className="">
                <form onSubmit={handleSubmit}>
                    <div className="mt-4">
                        <CustomInput
                            type="text"
                            label="Enter Name of the concern Person"
                            name="name"
                            val={name}
                            onChng={(e) => setName(e.target.value)}
                        />
                    </div>

                    <div className="mt-4">
                        <CustomInput
                            type="text"
                            label="Email Address"
                            name="email"
                            val={email}
                            onChng={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="mt-4">
                        <CustomInput
                            type="text"
                            label="Phone"
                            name="phone"
                            val={phone}
                            onChng={(e) => setPhone(e.target.value)}
                        />
                    </div>

                    <div className="mt-4">
                        <CustomInput
                            type="date"
                            label="Date"
                            name="date"
                            val={date}
                            onChng={(e) => setDate(e.target.value)}
                        />
                    </div>
                    {availableSlots.length > 0 && (
                        <div className="mt-4">
                            <label className="form-label">Select Time Slot:</label>
                            <select
                                name="timeSlotID"
                                className="form-control py-3 mt-3"
                                value={timeSlotID}
                                onChange={(e) => setTimeSlotID(e.target.value)}
                            >
                                <option value="">Select a time slot</option>
                                {availableSlots.map(slot => (
                                    <option
                                        key={slot._id}
                                        value={slot._id}
                                        disabled={!slot.available}
                                    >
                                        {slot.time} {slot.available ? '(Available)' : '(Booked)'}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}


                    <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
                        {getNewsId ? "Edit" : "Book"} Appointment
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Appointment;
